export default {
      id: "icon-add-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-add",
      toString: function () {
        return this.url;
      }
    }